/**
 *
 * Clear our overrideLock on each page navigation 
 *
 */
export default ({ store }) => {
    store.dispatch("applications/disableOverrideLock");
};
